<template>
    <div class="modal fade" id="add_update_res_categories_modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="add_update_res_categories_modalLabel">Add / Update Restaurant Categories</h4>
                </div>

                    <div class="modal-body">
                        <form id="categoryForm" method="post" @submit.prevent="addUpdateCategory()" enctype="multipart/form-data">
                        <div class="row">

                            <div class="col-lg-5">
                                <div class="form-group">
                                    <label>Name</label>
                                    <input v-model="category.name" type="text" class="form-control" required="required" placeholder="Name...">
                                </div>
                            </div>

                            <div class="col-lg-5">
                                <div class="form-group">
                                    <label>Category Picture</label><br/>
                                    <input v-on:change="handlePicture()" type="file" :required="this.update===false" class="form-control image" placeholder="Type...">
                                </div>
                            </div>

                            <div class="col-lg-2">
                                <div class="form-group">
                                    <button class="btn btn-primary btn-xs" style="margin-top: 25px;margin-right: 5px" type="submit"><i :class="this.update === true ? 'fa fa-pencil' : 'fa fa-plus'" ></i></button>
                                    <button class="btn btn-danger btn-xs" style="margin-top: 25px" v-on:click="cancelEdit()"  v-if="this.update===true"><i class='fa fa-times'></i></button>
                                </div>
                            </div>
                        </div>
                        </form>

                            <div class="row">
                                <div class="col-lg-12">
                                    <div v-bind:class="'sk-spinner sk-spinner-three-bounce ' + isHideSpinner">
                                        <div class="sk-bounce1"></div>
                                        <div class="sk-bounce2"></div>
                                        <div class="sk-bounce3"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="table-responsive" style="overflow: auto">
                                <table class="table table-striped table-bordered table-hover responsive" id="dtTable">
                                    <thead>
                                    <tr>
                                        <th>Image</th>
                                        <th>Name</th>
                                        <th>Edit</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    <tr v-for="item in categories" :key="item.id" >
                                        <td><img v-bind:src="item.imageUrl" alt="No image found" style="max-width: 20% ;max-height: 20%"></td>
                                        <td>{{ item.name }}</td>
                                        <td>&emsp;<a href="javascript:void(0)" style="color: inherit;"><i v-on:click="editCategory(item.id)" class="fa fa-pencil"></i></a></td>

                                    </tr>

                                    </tbody>
                                </table>
                            </div>

                        </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
            </div>
            </div>
        </div>

</template>

<script>
    /* eslint-disable */
    export default {
        name: "AddUpdateResCategories",
        data() {
            return {
                category: {
                    "id": 0,
                    "name": "",
                },
                update:false,
                image: null,
                categories:[],
                isHideSpinner:""
            }
        },
        mounted: function () {
            $('#add_update_res_categories_modal').on('hidden.bs.modal',  (e) => {
                this.resetData();
            });
        },
        methods: {
            load: function (){
                this.isHideSpinner = "";
                this.$http.get(this.$store.state.mainAppURL + "restaurant_categories/").then(resp => {
                        this.isHideSpinner = "hide";
                        this.categories = resp.data;
                    });
                $("#add_update_res_categories_modal").modal("show");
            },
            handlePicture: function() {
                let input =$(".image");
                if (input.prop('files')[0] !== undefined) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        input.prev().attr('src', e.target.result);
                    };
                    reader.readAsDataURL(input.prop('files')[0]);
                        this.image = input.prop('files')[0];
                }else{
                    input.prev().attr('src', "");
                }
            },
            editCategory: function (categoryId) {
                this.$http.get(this.$store.state.mainAppURL + "restaurant_categories/get_category_by_id", {params: {category_id: categoryId}}).then(resp => {
                    this.category = resp.data;
                    this.update = true;
                });
            },
            cancelEdit: function() {
                this.category = {
                    "id": 0,
                    "name": "",
                };
                this.update = false;
            },
            addUpdateCategory: function () {
                let formData = new FormData();
                formData.append("category", JSON.stringify(this.category));
                formData.append("image", this.image);
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                this.$http.post( this.$store.state.mainAppURL + "restaurant_categories/",
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data;'
                        }
                    }
                ).then((resp) => {
                    console.log(resp);
                    Swal.close();
                   if(resp.data){
                       swal("Saved Successfully", "success");
                       this.load();
                       this.image = "";
                       this.category.id = 0;
                       this.category.name = "";
                       this.update = false;
                       $('#categoryForm')[0].reset();
                   }else{
                       swal("Error!" ," Please Try Again", "error");
                   }
                }).catch((ex) => {
                    console.log('FAILURE!!');
                });
            },
            resetData: function () {
                Object.assign(this.$data, this.$options.data.call(this));
                $("input[type=file]").val("");
                $(".bigPic").prev().attr("src", "");
                $(".smallPic").prev().attr("src", "");
            }
        }
    }
</script>

<style scoped>

</style>
